export const sizes = {
    XP: '(min-width: 320px)',
    P: '(min-width: 480px)',
    M: '(min-width: 768px)',
    G: '(min-width: 1024px)',
    XG: '(min-width: 1281px)',
    XXG: '(min-width: 1440px)',
};
